module.exports = __webpack_public_path__ + "static/media/romulo.0deb4e9b.png";